import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/modules/material.module';

import { ViewModeActionComponent } from './view-mode-action/view-mode-action.component';

const COMPONENTS = [ViewModeActionComponent];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule, MaterialModule],
  exports: COMPONENTS,
})
export class PostAssetsActionsModule {}
